import React from 'react';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
  const handleClick = (href?: string) => {
    if (href) {
      window.location.href = href;
    }
  };

  return (
    <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
      <button
        onClick={() => handleClick('/home')}
        className="flex items-center gap-1 text-amber-600 hover:text-amber-700 transition-colors"
      >
        <Home className="w-4 h-4" />
        <span className="hidden sm:inline">Home</span>
      </button>
      
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
          
          {item.href && !item.current ? (
            <button
              onClick={() => handleClick(item.href)}
              className="text-amber-600 hover:text-amber-700 transition-colors whitespace-nowrap"
            >
              {item.label}
            </button>
          ) : (
            <span 
              className={`
                ${item.current 
                  ? 'text-gray-800 font-medium' 
                  : 'text-gray-500'
                }
                whitespace-nowrap
              `}
              {...(item.current && { 'aria-current': 'page' })}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export { Breadcrumb, type BreadcrumbItem };